var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('select',{attrs:{"multiple":_vm.multiple}},[_vm._t("default"),_vm._v(" "),_vm._l((_vm.data),function(v,k){return _c('option',{key:k,domProps:{"value":_vm.optValue(k,v)}},[_vm._v("\n    "+_vm._s(_vm.optLabel(k,v))+"      \n  ")])})],2)}
var staticRenderFns = []

export { render, staticRenderFns }